import { ReactElement, ReactNode, CSSProperties } from 'react';

type DashedBoxCSSProps = {
  stroke?: string; // e.g. "#333"
  strokeWidth?: number; // e.g. 2, 4
  dashArray?: string; // e.g. "6,14"
  dashOffset?: number; // e.g. 0
  borderRadius?: number; // optional, if you want it rounded
  linecap?: 'butt' | 'round' | 'square';
  width?: string | number; // e.g. '100%', '300px'
  height?: string | number; // e.g. '62px'
  children?: ReactNode;
  style?: CSSProperties;
};

export function DashedBoxCSS({
  stroke = '#333',
  strokeWidth = 2,
  dashArray = '6,14',
  dashOffset = 0,
  borderRadius = 0,
  linecap = 'square',
  width = '100%',
  height = '62px',
  children,
  style,
}: DashedBoxCSSProps): ReactElement {
  const encodedStroke = encodeURIComponent(stroke);
  const encodedDashArray = encodeURIComponent(dashArray);
  const encodedLinecap = encodeURIComponent(linecap);

  const backgroundImage = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${encodedStroke}' stroke-width='${strokeWidth}' stroke-dasharray='${encodedDashArray}' stroke-dashoffset='${dashOffset}' stroke-linecap='${encodedLinecap}'/%3e%3c/svg%3e")`;

  return (
    <div
      data-testid="dashed-box"
      style={{
        width,
        height,
        backgroundImage,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        borderRadius,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
